<template>
    <div>
        <label class="font-[Inter] text-sm font-semibold text-[#182333]">
            <slot />
        </label>
        <fieldset
            v-if="!showValue"
            :class="showAs === 'block' ? 'mt-5' : ''"
        >
            <div
                :class="[
                    radioButtonsWrapperClasses,
                    optionsContainerClass,
                    ...(inline ? ['flex'] : []),
                    showAs === 'block' ? 'flex flex-col gap-y-2.5' : ''
                ]"
            >
                <div
                    v-for="option in options"
                    :key="option.id"
                    :class="[
                        radioButtonClasses,
                        inline ? 'mr-7' : '',
                        showAs === 'block' ? 'flex items-center px-3 py-3.5 border border-won-gray-light rounded shadow-radio-card w-fit' : ''
                    ]"
                >
                    <input
                        :id="option.id"
                        type="radio"
                        @change="() => changed(option)"
                        :checked="option.value === selected"
                        class="w-0 h-0 hidden"
                    />
                    <label
                        :for="option.id"
                        class="flex items-center cursor-pointer"
                    >
                        <div
                            :class="[
                                'w-4 h-4 rounded-full border-2 m-0.5 flex items-center justify-center',
                            ]"
                            :style="{
                                borderColor:
                                    selected === option.value
                                        ? '#2A8176'
                                        : '#ACADAE',
                            }"
                        >
                            <div
                                v-if="selected === option.value"
                                class="w-[7px] h-[7px] rounded-full bg-[#2A8176]"
                            />
                        </div>

                        <div class="font-[Inter] ml-1 block font-normal text-sm text-[#182333]">
                            {{ option.title }}
                        </div>
                    </label>
                </div>
            </div>
        </fieldset>
        <div v-else class="won-label-text-color text-sm mt-2">
            {{
                options.find((e) => e.value === modelValue)?.title || modelValue
            }}
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, toRefs } from "vue";

const emit = defineEmits(['update:modelValue'])
const props = defineProps({
    options: {
        type: Array,
        default: []
    },
    modelValue: {
        type: [Object, String, Number, Boolean],
        default: null
    },
    inline: {
        type: Boolean,
        default: false
    },
    showValue: {
        type: Boolean,
        default: false
    },
    storageKey: {
        type: String,
        default: null
    },
    optionsContainerClass: {
        type: String,
        default: ''
    },
    showAs: {
        type: String,
        default: 'list'
    },
    radioButtonsWrapperClasses: {
        type: String,
        default: ''
    },
    radioButtonClasses: {
        type: String,
        default: ''
    }
})

const { storageKey, modelValue } = toRefs(props)
const selected = ref(modelValue.value);

onMounted(() => {
    if (props.storageKey) {
        const fullKey = `WONSULTING-${storageKey.value}`;
        const value = localStorage.getItem(fullKey);

        if (value) {
            selected.value = value;
            emit("update:modelValue", value);
        }
    }
});

const changed = (option) => {
    emit("update:modelValue", option.value);
    selected.value = option.value;

    if (storageKey.value) {
        const fullKey = `WONSULTING-${storageKey.value}`;
        localStorage.setItem(fullKey, option.value);
    }
}
</script>

<style></style>
